import {useQuery} from '@tanstack/react-query';
import {getFaqBody} from '@/api/help/faq';

interface UseGetFaqBodyProps {
  enabled: boolean;
  questionId: string;
}

export const useGetFaqBody = ({enabled, questionId}: UseGetFaqBodyProps) => {
  return useQuery({
    queryKey: ['help', 'faqBody', questionId],
    queryFn: () => getFaqBody({questionId}),
    enabled,
    select: ({data}) => ({
      contents: data.kbInfo.contents,
      title: data.kbInfo.title,
      subCategory: data.kbInfo.nodeId,
    }),
  });
};
